<template>
  <div class="d-flex align-center font-weight-bold primary--text my-2">
    <v-icon class="primary--text">
      fas fa-shield-alt
    </v-icon>
    <span class="ma-1">
        {{ user.team.role_name }}
      </span>
  </div>
</template>
<script>
export default {
  props: {
    user: {
      type: Object,
      required: true,
    }
  }
}
</script>
